export default __webpack_public_path__ + "static/media/caret-down.b86c99fa.svg";